/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S5_Intro_PostInputs */

const tr_kvkkbasvuru_s5_intro_post = /** @type {(inputs: Kvkkbasvuru_S5_Intro_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` veya KEP adresimize gönderebilirsiniz:`)
};

const en_kvkkbasvuru_s5_intro_post = /** @type {(inputs: Kvkkbasvuru_S5_Intro_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` or to our KEP address:`)
};

const de_kvkkbasvuru_s5_intro_post = /** @type {(inputs: Kvkkbasvuru_S5_Intro_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` oder an unsere KEP-Adresse senden:`)
};

const ru_kvkkbasvuru_s5_intro_post = /** @type {(inputs: Kvkkbasvuru_S5_Intro_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` или на наш адрес KEP:`)
};

/**
* | output |
* | --- |
* | "or to our KEP address:" |
*
* @param {Kvkkbasvuru_S5_Intro_PostInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s5_intro_post = /** @type {((inputs?: Kvkkbasvuru_S5_Intro_PostInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S5_Intro_PostInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s5_intro_post(inputs)
	if (locale === "de") return de_kvkkbasvuru_s5_intro_post(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s5_intro_post(inputs)
	return tr_kvkkbasvuru_s5_intro_post(inputs)
});